<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
*{-webkit-tap-highlight-color: rgba(0, 0, 0, 0);}
body,html{
  width: 100%;
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  background: #f1f1f1;
  font-size: 14px;
  box-sizing: border-box;
  height: 100%;
}
.el-message-box{
  width: 80%;
}
.el-button--primary{
  border-color: #a11b00!important;
  background: #a11b00!important;
}
.el-popper[x-placement^=bottom] .popper__arrow,
.el-popper[x-placement^=bottom] .popper__arrow::after{
  display: none!important;
}
.pubbutton{
  width: 40%;;
  display: block;
  margin: 40px auto 0;
  height: 35px;
  line-height: 35px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  background: -webkit-linear-gradient(left, #7b0000 , #ef6161); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(right, #7b0000, #ef6161); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(right, #7b0000, #ef6161); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #7b0000 , #ef6161); /* 标准的语法 */
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#7b0000, endColorstr=#ef6161);
  span{
    display: inline-block;
    width: 50%;
    height: 35px;
    text-align: justify;
    vertical-align: top;
    &::after {
       display: inline-block;
       width: 100%;
       content: '';
       height: 0;
     }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue